module.exports = __webpack_public_path__ + "img/_0.971dac2f.png";